import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Box, Button, createStyles, Dialog, Grid, IconButton, makeStyles, Theme, Typography, useTheme, Fade, Slide, TextField
} from '@material-ui/core';
import { ArrowBack, ArrowDownward, ArrowForward, ArrowRight, Close } from '@material-ui/icons';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import Icon from '@mui/material/Icon';

import { FareastButton } from './OverlayComponentButton';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { Order } from 'common-ts/dist/models/Orders';
import { BodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import { closeOverlayAndReset as closeOverlayAndResetEditView, openOverlay as openOverlayEditView, setValues as setValuesEditView } from '../redux/UIOverlayMeasurementEditViewRedux';
import React, { useEffect } from 'react';
import OverlayComponentButton from './OverlayComponentButton';
import { Player } from '@lottiefiles/react-lottie-player';
import { TypeAnimation } from 'react-type-animation';
import { ChipPropsVariantOverrides } from '@mui/material';
import { OfflineActiveScreen } from '../redux/UIOverlayOfflineRedux';
import { socket } from '../socket';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: 'black',
      borderRadius: '50%',
      padding: '5px',
    },
    backButtonIcon: {
      padding: '0',
      color: 'white',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      // padding: '1em 1.5em',
      // overflowY: 'hidden',
    },
    pageTitle: {
      marginTop: '1em',
      fontSize: '1.2em',
      width: '80%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.7em',
    },
  }),
);

export function StarWarsNameCard({name, isOneName=false, isTextType=false, fontSizeManual=undefined}: {name: string, isOneName?: boolean, isTextType?: boolean, fontSizeManual?: string}) {
  return (
    <Box style={{
      width: '100%',
      position: 'relative',
      margin: '30px 0px 2px',
      minHeight: '80%',
    }}>
      <video muted autoPlay loop src={'https://studiosclo.uk/general/Profil_Personal_Fit_Card_05.mp4'}
      playsInline
        style={{
          width: '100%'
        }}
      />
      <Typography style={{
        position: 'absolute',
        top: '75%',
        left: '28%',
        fontSize: '10%',
        fontWeight: 500,
        color: '#ffffff',
      }}>
        {new Date().toLocaleDateString()}
      </Typography>
      {
        isTextType ? 
        <Typography style={{ 
          position: 'absolute',
          top: '52.3%',
          left: '28%',
          fontSize: fontSizeManual ? fontSizeManual : '3.3vw',
          fontFamily: 'OakesGrotesk',
          fontWeight: 500,
          color: '#ffffff',
        }}>
          {name}
        </Typography>:
      <TypeAnimation
        sequence={
          isOneName ? [
          name,
          2400, 
          'KAMU',
          2400
        ] : [
          'Louis',
          900, // Waits 1s
          name,
          2400, // Waits 1s
          'Ubay', 
          900, // Waits 1s
          'Mike',
          900,
          'KAMU',
          3400
        ]}
        wrapper="div"
        cursor={true}
        repeat={Infinity}
        style={{ 
          position: 'absolute',
          top: '54.1%',
          left: '28%',
          fontSize: '4.3vw',
          fontFamily: 'OakesGrotesk',
          fontWeight: 500,
          color: '#ffffff',
        }}
        speed={12}
      />
      }
    </Box>
  )
}

interface Props {
  currentName?: string
  handleNext: (firstName: string) => void
}

export default function PersonalSizeBenefit({ currentName=undefined, handleNext }: Props) {
  const classes = useStyles();

  const [draftFirstName, setDraftFirstName] = React.useState<string>('');

  useEffect(() => {
    socket.timeout(5000).emit('chat message', {
      currentStore: 'STORE1',
      currentScreen: OfflineActiveScreen.BenefitStart,
      firstName: draftFirstName,
    });
  }, [draftFirstName]);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      // Ignore functional keys like Shift, Control, Alt
      if (event.key.length === 1) {
        setDraftFirstName((prev) => prev + event.key);
      } else if (event.key === "Backspace") {
        setDraftFirstName((prev) => prev.slice(0, -1));
      } else if (event.key === "Spacebar" || event.key === " ") {
        setDraftFirstName((prev) => prev + " ");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    
    // Clean up listener on unmount
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
    <Box  id='univ-size-benefit-0' ></Box>
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      height: '100vh',
    }}>
      <Box id='univ-size-benefit-3' style={{
        width: currentName !== undefined ? '100%' : '45%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Typography style={{fontSize: '15px', fontWeight: 600, letterSpacing: '0.3px'}}>BUAT PERSONAL FIT KAMU</Typography>
        <StarWarsNameCard name={currentName ? currentName : draftFirstName} isTextType={true} fontSizeManual={currentName !== undefined ? '8vw' : undefined}/>
        {/* <TextField value={draftFirstName} onChange={(e: any) => {setDraftFirstName(String(e.target.value))}} style={{visibility: 'hidden'}} onBlu/> */}
        <Box style={{
          marginTop: '20px',
          border: draftFirstName ? '1px solid black' : '1px solid #787878',
          color: draftFirstName ? 'black' : '#787878',
          borderRadius: '40px',
          padding: '3px 6px 3px 14px',
          display: 'flex',
          justifyContent: 'space-between',
          width: '69px',
          cursor: 'pointer',
        }} onClick={() => handleNext(draftFirstName)}>
          <Typography style={{fontSize: '12px', fontWeight: 500, paddingTop: '4px', letterSpacing: '0.3px'}}>
            MULAI 
          </Typography>
          <ArrowRight/>
        </Box>
      </Box>
    </Box>
    </>
  );
}